import axios from "axios";
import authHeader from './auth-header';
import crypto from "crypto";
import jwtDecode from "jwt-decode";




const API_URL = "http://50.50.50.50/api/auth/";

class AuthService {

  login(username, password) {





          let response = {}
 response.data = {
  id: 2900,
  username: 'test.user',
  userfullname: 'Demo User',
  department: 'IT',
  roles: [ 'ROLE_ADMIN', 'ROLE_AGENT', 'ROLE_HELPDESK', 'ROLE_NETWORK' ],
  accessToken: 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6MjkwMCwiaWF0IjoxNjQ2MjM2NDE0LCJleHAiOjE2NDY1ODIwMTR9.DmXwdBk2HrPVCe8TCwiPcSPEnpSmNqplixrIo5aVFOA'
}


          localStorage.setItem("user", JSON.stringify(response.data));
        
        return response.data;
  }

  logout() {
    localStorage.removeItem("user");
    window.location.reload();
  }

  register(username, email, password) {
    return axios.post(API_URL + "signup", {
      username,
      email,
      password
    });
  }



  checkTokenExpirationMiddleware () {
if (localStorage.getItem("user")) {

    const token =
      JSON.parse(localStorage.getItem("user")) &&
      JSON.parse(localStorage.getItem("user"))["accessToken"];



}
  };



  getCurrentUser =() => {



    

    //uncomment below if need to recheck backend connectivity and token on each route
 /* axios.get( 'http://50.50.50.50/brwsrverifytbkend', { headers: authHeader() })
.then(response => {
        if (response.data.accessgranted === true) {
console.log('access granted')
        }
else { localStorage.removeItem("user");
}


      }).catch(function (error) {

if (error) {localStorage.removeItem("user")}      

      })


if (JSON.parse(localStorage.getItem('user'))) {return JSON.parse(localStorage.getItem('user'));
}
   
else {

  return false
}*/



return JSON.parse(localStorage.getItem('user'))

  }



  getCurrentsocket() {

return JSON.parse(localStorage.getItem('socketio'))

  }




}

export default new AuthService();
